module.exports = __webpack_public_path__ + "static/949781856.dc7aede5.jpg";